import {
  phoneVerificationInterceptor,
  twoFAInterceptor,
} from '@marketplace-web/domain/verification'
import {
  anonIdInterceptor,
  API_BASE_PATH,
  ApiClient,
  appendAcceptWebPHeaderInterceptor,
  csrfTokenInterceptor,
  errorInterceptor,
  localeInterceptor,
  proxyApiV2ToMarketplaceWeb,
} from '@marketplace-web/shared/api-client'
import { ClientCookieManager, cookiesDataByName } from '@marketplace-web/shared/cookies'
import { tokenRefreshInterceptor } from 'data/api/authentication/interceptors'

export const cookies = new ClientCookieManager()

export const baseURL = API_BASE_PATH

export const api = new ApiClient({ baseURL }, [
  csrfTokenInterceptor,
  errorInterceptor,
  tokenRefreshInterceptor,
  localeInterceptor,
  phoneVerificationInterceptor,
  twoFAInterceptor,
  anonIdInterceptor,
  cookies.get(cookiesDataByName.supports_webp) ? appendAcceptWebPHeaderInterceptor : undefined,
  cookies.get(cookiesDataByName.proxy_api_v2_feature) ? proxyApiV2ToMarketplaceWeb : undefined,
])
